import { render, staticRenderFns } from "./field.vue?vue&type=template&id=5c179d8b&scoped=true"
import script from "./field.vue?vue&type=script&lang=js"
export * from "./field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c179d8b",
  null
  
)

export default component.exports